// since there's no dynamic data here, we can prerender
// it so that it gets served as a static asset in production
export const ssr = true
export const prerender = true

import { getServerLocale } from '~/utils/getServerLocale'
import { ContentManagerSystem } from '../config/content-manager-system'
import type { PageLoad } from './$types'

const requestManagerSystem = ContentManagerSystem(`
query HomeQuery($locale: SiteLocale = pt_BR) {
  homePage(locale: $locale) {
    metadata {
      description
      title
    }
    
    id
    title
    links
    description

    serviceShelf {
      id
      icon
      title
      description
    }

    portfolioWork {
      id
      slug
      title
      description
      image {
        url
        alt
      }

      customer {
        name
        image {
          url
          alt
        }
      }
      
    }
    
    aboutTitle
    serviceTitle
    contactTitle
    portfolioTitle
    
    aboutDescription
    contactDescription
    portfolioDescription

    portfolioLinks

    contactForm
  }
}
`)

export const load: PageLoad = async (request) => {
  const locale = getServerLocale('pt-br')

  const response = await requestManagerSystem({ locale: locale.contentManagerSystem })

  return response.homePage
}
